"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = Calendar;
var _Calendar = require("@adobe/react-spectrum-workflow/dist/Calendar.js");
var _icon = require("@react-spectrum/icon");
var _react = _interopRequireDefault(require("react"));
function Calendar(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Calendar.A4uCalendar, null));
}